import * as d3 from 'd3-selection'
import drawSvg from './draw-svg'
import drawLegend from './draw-legend'
import setContentClasses from './set-content-classes'

var draw = function (widgetView, data) {
	let el = widgetView.el
	var d3root = d3.select(el).selectAll('.content')

	d3root = d3root.data([data])

	var enter = d3root.select('.content').enter()

    var all = enter.merge(d3root)
	setContentClasses(all)

	widgetView.$el.toggleClass('has-visible-shape',
		widgetView.model.isShapeVisible())

	drawLabel(widgetView, all, data)
	drawSvg(widgetView, enter, all, data)

	// Draws the "legend", which contains optional labels like score, actual value, etc
	drawLegend(enter, all)
}

/**
 * Draws the label (called "title" in the CSS) above the shape SVG
 */
function drawLabel (widgetView, update, data) {
	let label = data.properties.label
	widgetView.$el.toggleClass('has-title', !!label)
	update.select('.title-text h3')
		.text(d => label)
}

export default draw

draw.__filename__ = 'dashboards/widgets/shape/view/draw.js'
